var EMPTY_DOCUMENT, INITIAL_DIALOG_STATE, INITIAL_STATE, MiniDSActions, convertListToOrderedMap, generateStore;

generateStore = require('stores/utils/generate_store');

MiniDSActions = require('actions/mini_ds_actions');

convertListToOrderedMap = require('lib/immutable_utils').convertListToOrderedMap;

EMPTY_DOCUMENT = Immutable.fromJS({
  name: '',
  template: ''
});

INITIAL_DIALOG_STATE = Immutable.fromJS({
  applying: false,
  isOpen: false,
  document: EMPTY_DOCUMENT
});

INITIAL_STATE = Immutable.fromJS({
  dialog: INITIAL_DIALOG_STATE,
  isFetching: false,
  document: {}
});

module.exports = generateStore({
  name: 'MiniDSStore',
  initialState: INITIAL_STATE,
  boundActions: [MiniDSActions],
  methods: {
    isFetching: function() {
      return this.state.get('fetching');
    },
    onDbChange: function(_arg) {
      var doc;
      doc = _arg.doc;
      return this.setState(this.state.set('document', Immutable.fromJS(doc)));
    },
    isCreateOrEditDialogOpen: function() {
      return this.state.getIn(['dialog', 'isOpen']);
    },
    isApplying: function() {
      return this.state.getIn(['dialog', 'applying']);
    },
    getEditingDocument: function() {
      return this.state.getIn(['dialog', 'document']);
    },
    onOpenCreateOrEditDialog: function(doc) {
      if (doc == null) {
        doc = EMPTY_DOCUMENT;
      }
      return this.setState(this.state.withMutations(function(s) {
        s.setIn(['dialog', 'isOpen'], true);
        return s.setIn(['dialog', 'document'], doc);
      }));
    },
    onCloseCreateOrEditDialog: function() {
      return this.setState(this.state.set('dialog', INITIAL_DIALOG_STATE));
    },
    onCreateDocument: function() {
      return this.setState(this.state.setIn(['dialog', 'applying'], true));
    },
    onUpdateDocument: function() {
      return this.setState(this.state.setIn(['dialog', 'applying'], true));
    },
    onFetch: function() {
      return this.setState(this.state.set('fetching', true));
    },
    onFetchSuccess: function(doc) {
      return this.setState(this.state.withMutations(function(state) {
        state.set('fetching', false);
        return state.set('document', Immutable.fromJS(doc));
      }));
    },
    getCurrentDocumentId: function() {
      return this.state.getIn(['document', '_id']);
    },
    getCurrentDocumentName: function() {
      return this.state.getIn(['document', 'name']);
    },
    getDocument: function() {
      return this.state.get('document', Immutable.Map());
    }
  }
});
